<template>
  <div class="p-0 mb-50">
    <div class="mt-30 container-style mb-30">
      <div class="p-20 activity-form">
        <div class="container">
          <div class="tags-page__header d-flex">
            <a href="javascript:void(0)" class="d-block tags-page__back-to-activities fs-14" data-toggle="modal" data-target="#cancelInfoModal">{{ this.$route.name == "study-schedule-packet" ? "Activities" : "Data Capture Forms" }}&nbsp;</a>

            /
            <a href="javascript:void(0)" class="d-block tags-page__back-to-activities fs-14" data-toggle="modal" data-target="#Modalforcreateeditpacket">Edit Packet&nbsp;</a>
            <!-- <span>/ Edit Packet</span> -->
            <span>/ Schedule Packet</span>
          </div>
          <div class>
            <div class="mt-30 container-style">
              <div class="p-20">
                <div class>
                  <div class="fw-500 fs-20">Schedule Packet</div>
                  <div class="pt-20 clearfix survey_qs">
                    Which method would you like to schedule with?
                    <span class="required">*</span>
                  </div>
                  <activityScheduler
                    v-model="scheduler"
                    :options="{
                      validateFor: 'Packet',
                      formId: packetId,
                      type: 'Packet'
                    }"
                  ></activityScheduler>
                </div>
                <div class="pt-20 mb-70">
                  <span v-on:click="goBack()" class="ml-10 back_link">
                    <i class="fa fa-caret-left" aria-hidden="true"></i>
                    Back
                  </span>
                </div>
                <div class="row mt-70 mb-100">
                  <div class="col-md-12 text-right p-0">
                    <button type="button" class="cancel-btn" data-toggle="modal" data-target="#cancelInfoModal">
                      <span class="cancel-btn-text">Cancel</span>
                    </button>
                    <button type="button" class="continue-btn" v-on:click="onContinuePacket()">
                      <span class="continue-btn-text">Complete</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="cancelInfoModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
              <!-- Modal content-->
              <div class="modal-content">
                <div class="modal-header border-none">
                  <a class="cursor_pointer close modal-close pt-5 pr-10" data-dismiss="modal">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </a>
                </div>
                <div class="modal-body pt-0">
                  <span class="modal-text-cancel">You are leaving this page, any unsaved scheduling will be lost.</span>
                  <div class="row d-flex justify-content-center mt-30 mb-21">
                    <button type="button" class="cancel-modal-btn" data-dismiss="modal">
                      <span class="cancel-modal-text">Cancel</span>
                    </button>
                    <button type="button" class="continue-btn-modal ml-10" data-dismiss="modal" v-on:click="onContinuePacketModal()">
                      <span class="continue-btn-text">Continue</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="Modalforcreateeditpacket" class="modal fade" role="dialog">
            <div class="modal-dialog">
              <!-- Modal content-->
              <div class="modal-content">
                <div class="modal-header border-none">
                  <a class="cursor_pointer close modal-close pt-5 pr-10" data-dismiss="modal">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </a>
                </div>
                <div class="modal-body pt-0">
                  <span class="modal-text-cancel">You are leaving this page, any unsaved scheduling will be lost.</span>
                  <div class="row d-flex justify-content-center mt-30 mb-21">
                    <button type="button" class="cancel-modal-btn" data-dismiss="modal">
                      <span class="cancel-modal-text">Cancel</span>
                    </button>
                    <button type="button" class="continue-btn-modal ml-10" data-dismiss="modal" v-on:click="onContinueeditpacketModal()">
                      <span class="continue-btn-text">Continue</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
import activityScheduler from "@/components/activity-library/activity-scheduler";

export default {
  name: "scheduler",
  data() {
    return {
      packetId: null,
      packetMilestones: [],
      studyId: null,
      studyData: {},
      milestones: [],
      frequencies: [
        { type: "daily", title: "Daily", days: 1 },
        { type: "weekly", title: "Weekly", days: 7 },
        { type: "biweekly", title: "Every 2 Weeks", days: 15 },
        { type: "monthly", title: "Monthly", days: 30 },
        { type: "biannually", title: "Bi-annually", days: 180 },
        { type: "annually", title: "Annually", days: 360 }
      ],
      scheduler: {
        type: "milestone",
        milestones: [],
        frequency: {},
        startDay: null,
        endDay: null,
        completionWindow: null,
        reminders: [{}],
        allowMultipleTimes: false,
        allowUntillDuration: false
      },
      exampleMileStone: [
        { date: "Day1", day: "Wed", class: "bg-green" },
        { date: "Day2", day: "Thur", class: "" },
        { date: "Day3", day: "Fri", class: "" },
        { date: "+2", day: "Sat", class: "bg-red" }
      ],
      prePopulationEnabled: false,
      sentToTeam: null
      // taskType: null
    };
  },
  components: { activityScheduler },
  mounted() {
    this.studyId = this.$route.params.studyId;
    this.packetId = this.$route.params.packetId;
    this.getStudyDetails();
  },
  computed: {
    schedulerObjChanged() {
      return this.$store.getters.getSchedulerObjData;
    },
    activitySchedulingMode() {
      return this.scheduler.activitySchedulingMode ? this.scheduler.activitySchedulingMode : "schedule";
    }
  },
  watch: {
    schedulerObjChanged: {
      handler(val) {
        if (val.schedulerObj) {
          this.schedulePacket(val.schedulerObj);
        }
      }
    }
  },
  methods: {
    goBack() {
      window.history.back();
    },
    onContinueeditpacketModal() {
      this.$router.push({
        name: this.$route.name == "study-schedule-packet" ? "study-create-edit-packet" : "create-edit-packet",
        params: { studyId: this.studyId, packetId: this.packetId }
      });
    },
    onContinuePacketModal() {
      this.$router.push({
        name: this.$route.name == "study-schedule-packet" ? "study-activities" : "forms-list",
        params: { studyId: this.studyId, packetId: this.packetId }
      });
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    onContinuePacket() {
      this.$store.dispatch("addSchedule", { validateFor: "Packet" });
    },
    schedulePacket(scheduler) {
      const data = {
        scheduleId: scheduler.scheduleId,
        taskId: this.packetId,
        taskType: "Packet",
        duration: scheduler.scheduleType == "custom" ? scheduler.duration : null,
        type: scheduler.scheduleType,
        completionWindow: scheduler.scheduleType == "custom" ? scheduler.completionDuration : null,
        frequency: scheduler.scheduleType == "custom" ? scheduler.frequency : null,
        completionWindows: scheduler.scheduleType == "milestone" ? scheduler.completionWindows : null,
        allowMultipleTimes: scheduler.allowMultiReponseInCompletionWindow,
        showDailySummary: scheduler.showDailySummary,
        allowUntillDuration: scheduler.allowUntillDuration,
        milestones: scheduler.scheduleType == "milestone" ? scheduler.milestones : null,
        activitySchedulingMode: scheduler.activitySchedulingMode,
        segmentId: scheduler.scheduleType == "custom" ? scheduler.segmentId : null,
        formType: "Packet"
      };

      if (data.milestones && data.milestones.length) {
        data.milestones.map(eleOld => {
          let ele = eleOld;
          if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
            ele = Number(ele + this.studyData.screeningDuration);
          } else {
            ele = Number(ele);
          }
          return ele;
        });
      }
      this.$api.postScheduleActivityPacketFact(this.studyId, this.packetId, data).then(
        () => {
          setTimeout(() => {
            this.$toastr.success("Packet scheduled successfully.");
          }, 1200);
          this.$router.push({
            name: this.$route.name == "study-schedule-packet" ? "study-activities" : "forms-list",
            params: { studyId: this.studyId, packetId: this.packetId }
          });
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while the scheduling the packet");
        }
      );
    },
    getRecipientFlag() {
      this.$api.getRecipientFlag(this.studyId, this.surveyId).then(
        response => {
          this.sentToTeam = response.body && response.body.isNotificationRecipient ? response.body.isNotificationRecipient : false;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    addScheduler(scheduleObj) {
      this.$api.postSchedulingFact(this.studyId, scheduleObj).then(
        () => {
          toastr.success("Scheduling completed successfully");
          this.$router.push({
            name: "survey-review",
            params: { studyId: this.studyId, surveyId: this.surveyId }
          });
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while the scheduling the survey");
        }
      );
    },
    changeStatus() {
      const data = {};
      data.prePopulationEnabled = this.prePopulationEnabled;
      this.$api.updateSurveyPrepopulationFact(this.surveyId, this.studyId, data).then(
        response => {
          this.prePopulationEnabled = response.body.prePopulationEnabled;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while updating the survey details");
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.bg-green {
  background-color: #2ecc71 !important;
}

.bt-1 {
  border-top: 1px solid #d3dfe4;
}

.bg-red {
  background-color: #ff7171 !important;
}

.container-style {
  border-radius: 2px;
  background-color: #ffffff;
  color: #666769;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.example {
  margin: 40px 40px 20px 40px;
}
.example-content {
  padding: 20px 40px 20px 40px;
}
.example-header {
  padding: 20px 80px 10px 80px;
  font-weight: bold;
}

.form-control {
  border-radius: 2px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}

.footerStyle {
  .row {
    display: block;

    &:after {
      content: "";
      clear: both;
      display: block;
    }
  }
}

.back_link {
  color: #6d6d88 !important;
}

.survey_qs {
  font-weight: 600;
  color: #666769;
}

.add {
  width: 120px;
  height: 30px;
  border-radius: 4px;
  background-color: #1e8fe1;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  border: none;
}

.left-margin {
  margin-left: 20px;
}

.divider {
  width: 1080px;
  height: 1px;
  background-color: #d3dfe4;
  margin-top: 30px;
}

.email-div {
  margin-top: 30px;
  margin-bottom: 50px;

  .heading {
    font-size: 20px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: #666669;
  }

  .email-div1 {
    margin-top: 20px;

    .txt {
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #666669;
    }

    .txt1 {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #666669;
    }
  }

  .email-div2 {
    margin-top: 30px;

    .heading {
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #666669;
    }

    input[type="text"] {
      width: 300px;
      height: 40px;
      border-radius: 3px;
      border: 1px solid #d3dfe4;
      padding: 10px 8px;
    }

    input[type="text"]::placeholder {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #c5d1d6;
    }
  }

  .email-div3 {
    margin-top: 20px;

    .txt {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #666669;
    }

    .txt-remove {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #f16559;
      padding-left: 20px;
      cursor: pointer;
    }
  }
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
  padding-left: 0;
  display: block;
}

.is-danger {
  border-width: 2px;
  border-radius: 5px;
  border-color: #f16559 !important;
}

.recipientBtnDisabled {
  opacity: 0.5;
}

.checkbox_position {
  position: relative;
  top: 2px;
}

.info-circle-div {
  width: 330px;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
  padding: 15px 18px;
  position: absolute;
  border-radius: 3px;
  margin-left: 270px;
  margin-top: -70px;
  border: 1px solid #dbe5e9;
}
.site-team {
  width: 390px;
  margin-top: -63px;
}

.info-circle {
  padding: 0 15px;
}
.required {
  color: #ff0000;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
}
.continue-btn {
  width: 122px;
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  outline: none;
}
.continue-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.cancel-btn {
  width: 122px;
  height: 36px;
  background-color: #ffffff !important;
  border-radius: 100px;
  border: solid 2px #ffffff !important;
  cursor: pointer;
  outline: none;
}
.cancel-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}
.cancel-modal-btn {
  width: 150px;
  height: 36px;
  background-color: #e0e0e0;
  border-radius: 100px;
  border: solid 2px #ffffff !important;
  cursor: pointer;
  outline: none;
}
.cancel-modal-text {
  font-size: 14px;
  color: #000000;
}
.continue-btn-modal {
  width: 150px;
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  outline: none;
}

.modal-text-cancel {
  padding: 0px 33px;
  text-align: center;

  display: block;
  font-size: 18px;
}
.activity-form {
  min-height: 647px;
  position: relative;
  padding-top: 45px !important;
  // padding-right: 30px !important;
}
.activity-mode-opacity {
  visibility: hidden;
}
</style>
